var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pb-0"},[_c('v-data-table',{ref:"table",staticClass:"enter-marks-table",attrs:{"items":_vm.table2Records,"loading":_vm.loading,"headers":_vm.headers,"height":_vm.height,"fixed-header":"","disable-pagination":"","hide-default-footer":""},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
var rowIndex = ref.rowIndex;
return [_c('Record',{attrs:{"studentRecord":item,"row-index":rowIndex}})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }